import { createUseStyles } from 'react-jss';

import { scrollbar } from '@picsart/design-system/styleUtils/scrollbar';
import { FontFamilies } from '@picsart/design-system/foundation/fonts';
import { NegativeColors, PrimaryColors } from '@picsart/design-system/foundation/colors';
import { Spacings as CascadeSpacings } from '@picsart/design-system/foundation/spacings';

const useAppStyles = createUseStyles<string, any>(
  {
    '@global': {
      html: {
        // v13's foundation.css ships the @font-face rules but leaves the base
        // family to the app — previously useFoundation() applied it for us.
        fontFamily: FontFamilies.gilroy,

        '&.desktop:not(.embed)': {
          ...scrollbar(),
          minWidth: 1024,

          '@media screen and (max-width: 1023px)': {
            minWidth: 0,
          },
        },
        '&.embed-full': {
          width: '100%',
          height: '100%',
          '& > $body': {
            width: '100%',
            height: '100%',
          },
          '& #__next': {
            width: '100%',
            height: '100%',
          },
        },
        '&.mobile': {},
      },
      body: {
        '&.no-scroll': {
          height: '100vh',
          overflow: 'hidden',
        },
      },
      '#__next': {
        containIntrinsicSize: '100vh',
      },
      '.next-image-temp': {
        position: 'absolute',
        display: 'block',
        width: 0,
        height: 0,
        padding: CascadeSpacings.s0,
        inset: 0,
        minWidth: '100%',
        maxWidth: '100%',
        minHeight: '100%',
        maxHeight: '100%',
      },
      '::selection': {
        color: NegativeColors.text.default,
        backgroundColor: PrimaryColors.base.default,
      },
    },
  },
  {
    name: 'app',
  },
);

export default useAppStyles;
